/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-vars */
import {
  get as getAxios,
  post as postAxios,
  put as putAxios,
  deleteCall as deleteAxios,
} from "../apiHandler";

const endPoint = process.env.REACT_APP_API_BASE_URL;
const PAGE_SIZE = 10;

// const accessTokenFromLocal = "0fc0515a-d081-4b4a-83ab-7c104c2e1357";

const get = (url, { data, accessToken }) =>
  getAxios(url, { data, accessToken, endPoint });
const post = (url, { accessToken, data, params }) =>
  postAxios(url, { accessToken, data, endPoint, params });
const put = (url, { accessToken, data, params }) =>
  putAxios(url, { accessToken, data, endPoint, params });
const deleteCall = (url, { accessToken, data, params }) =>
  deleteAxios(url, { accessToken, data, endPoint, params });

export default class Files {
  static getUploadedFiles({ pageNumber = 0, size }) {
    const accessTokenFromLocal = localStorage.getItem("authToken");
    const request = get(`/api/contents?page=${pageNumber}&size=${size}`, {
      accessToken: accessTokenFromLocal,
    });

    Files.getUploadedFiles.cancel = request.cancel;
    return request;
  }

  static uploadFiles(data) {
    const accessTokenFromLocal = localStorage.getItem("authToken");
    const request = post(`/api/contents`, {
      accessToken: accessTokenFromLocal,
      data,
    });

    Files.uploadFiles.cancel = request.cancel;
    return request;
  }

  static uploadFileAttachments({ data }) {
    const accessTokenFromLocal = localStorage.getItem("authToken");
    const headers = {
      "Content-Type": "multipart/form-data",
    };
    const request = post(`/api/contents/uploadFile`, {
      accessToken: accessTokenFromLocal,
      data,
      headers,
    });

    Files.uploadFileAttachments.cancel = request.cancel;
    return request;
  }

  static updateFiles(data, id) {
    const accessTokenFromLocal = localStorage.getItem("authToken");
    const request = put(`/api/contents/${id}`, {
      accessToken: accessTokenFromLocal,
      data,
    });

    Files.updateFiles.cancel = request.cancel;
    return request;
  }

  static deleteDoc(documentId) {
    const accessTokenFromLocal = localStorage.getItem("authToken");
    const request = deleteCall(`/api/contents/${documentId}`, {
      accessToken: accessTokenFromLocal,
    });

    Files.deleteDoc.cancel = request.cancel;
    return request;
  }

  static downloadDocument(documentId) {
    const accessTokenFromLocal = localStorage.getItem("authToken");
    const request = get(`/api/contents/${documentId}/download`, {
      accessToken: accessTokenFromLocal,
    });

    Files.downloadDocument.cancel = request.cancel;
    return request;
  }
}
